exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wallet-step .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 37px;\n}\n.wallet-step .btn-container .btn {\n    min-width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04afdd6d","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/FillWalletAddress.vue
// module id = YHHz
// module chunks = 1